import { NgModule } from '@angular/core';
import { AnalyticsChartsProvider } from './analytics-charts.provider';

@NgModule({
  providers: [AnalyticsChartsProvider],
})
export class AnalyticsChartsCoreModule {}
